import { colors } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import { deDE, enUS, frFR, nlNL } from "@material-ui/core/locale";
import shadows from "./shadows";
import typography from "./typography";
import { getLang, getTranslation } from "../heplers/translationHelper";

// Material UI's own texts (pagination, autocomplete, alerts...) in the app language;
// the language only changes with a page reload, so the theme is built once
const MUI_LOCALES = { en: enUS, fr: frFR, gr: deDE, dt: nlNL };
const muiLocale = MUI_LOCALES[getLang()] || frFR;
const of = getTranslation("of");
const localeOverrides = {
	props: {
		MuiTablePagination: {
			labelRowsPerPage: getTranslation("Rows per page:"),
			labelDisplayedRows: ({ from, to, count }) => `${from}-${to} ${of} ${count !== -1 ? count : `> ${to}`}`,
		},
		MuiAutocomplete: {
			noOptionsText: getTranslation("No options"),
		},
	},
};

const theme = createTheme({
	palette: {
		background: {
			dark: "#F4F6F8",
			default: colors.common.white,
			paper: colors.common.white,
		},
		primary: {
			main: "#004467",
			light: "#f33333",
			dark: "#CC6E00",
			contrastText: "#ffffff",
		},
		secondary: {
			main: "#FA8900",
			dark: "#FF8A00",
			light: "#f33333",
			contrastText: "#000000",
		},
		text: {
			primary: colors.blueGrey[600],
			secondary: colors.blueGrey[600],
		},
		neutral: {
			main: "#F4F6F8",
			contrastText: "#fff",
		},
	},
	shadows,
	typography,
}, muiLocale, localeOverrides);

// merge, do not replace: theme.props also holds the language texts set above
theme.props = {
	...theme.props,
	MuiButton: {
		disableElevation: true,
	},
};

theme.overrides = {
	MuiButton: {
		root: {
			textTransform: "none",
		},
	},
};

export default theme;
